<template>
  <ul v-if="data" :class="$style.root">
    <template
      v-for="(group, key) in groups"
      :key="key"
    >
      <li :class="$style.group">
        <div :class="$style.groupKey">
          {{ key }}
        </div>
        <ul :class="$style.items">
          <li
            v-for="item in group"
            :key="item?.id"
          >
            <pages-editions-slug-participants-list-thumbnail-component
              :id="item?.id"
              :data="item"
            />
          </li>
        </ul>
      </li>
    </template>
  </ul>
</template>

<script lang="ts" setup>
import { groupBy } from 'lodash-es'

const props = defineProps({
  data: Array
})

const groups = computed(() => {
  return groupBy(props?.data, (i) => { return i?.sortKey })
})
</script>

<style module lang="scss">
.root {
  composes: reset-list container from global;
  padding: 0 var(--unit--horizontal);

  columns: 3;
  gap: var(--unit--horizontal);

  margin-bottom: calc(var(--lh, 1em) * -1);

  @media (max-width: $breakpoint-s) {
    columns: 2;
  }
}

.groupKey {
  text-transform: uppercase;
  color: var(--color--secondary);
}

.group {
  composes: reset-list from global;

  padding-bottom: var(--lh, 1em);

  break-inside: avoid;
}

.items {
  composes: reset-list from global;
}
</style>
